import {Record as record} from 'immutable';

export default record(
    {
        badges: [],
        unitSpaces: {},
        unitContentItems: [],
        unitMetadata: [],
        propertyContentItems: [],
        urgencyMessage: null,
        imageMetadata: {}
    },
    'listingExtended'
);
